<template>
    <div>
        <div class="card-body text-center">
            <p class="aboutscroll">
                <i class="fas fa-hourglass-half"></i>&nbsp;Seller has shipped trade items.
            </p>
            <button @click="completeTrade()" class="btn btn-info m-t-40" type="button">Complete</button>
            <div class="card-body text-center">
                <p class="text-center aboutscroll">
                    After the shipment arrives you can complete the trade. If you wish to dispute this transaction, please click on Open Dispute button below.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Shipped",
        methods: {
            completeTrade() {

            }
        }
    }
</script>

<style scoped>

</style>
